import React from "react";
import { connect } from "react-redux";

import history from '../../history'

import "./userHeader.css";

import UserHeaderLogo from '../../assets/images/gmass-logo-auth.png'
import { logOut, switchHomeSection } from "../../actions";

export class UserHeader extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      selectedMenu: ''
    };

    if (!this.props.auth.tokenId) {
      
      history.push('/login')
      
    }else if(this.props.auth.tokenId && this.props.auth.expiry < Date.now()){
      this.props.logOut()
    }

  }

  switchMenu = (event) => {
    this.setState({
      selectedMenu: event.target.id
    })
    this.props.switchHomeSection(event.target.id)
    
  }

  componentDidMount() {
    if (history.location.pathname.includes('/log')) {
      this.setState({
        selectedMenu: 'header-menu-logs'
      })

      this.props.switchHomeSection('header-menu-logs')

    } else if(history.location.pathname.includes('/campaign')) {
      this.setState({
        selectedMenu: 'header-menu-campaign'
      })

      this.props.switchHomeSection('header-menu-campaign')

    }else if(history.location.pathname.includes('/coldSmtp')){
      this.setState({
        selectedMenu: 'header-menu-coldsmtp'
      })

      this.props.switchHomeSection('header-menu-coldsmtp')
    }


  }

  goToHomePage = () =>{
    window.location.href="/campaign";
  }

  render() {
    return (
      <div className="UserHeader">
        <div className="UserHeader-logo" >
          <img src={UserHeaderLogo} alt="Logo" onClick={this.goToHomePage} ></img>
          <div className="header-logo-text">Support</div>
        </div>
        <div className="UserHeader-menu">
          <ul>
            <li id="header-menu-campaign" className={this.state.selectedMenu === "header-menu-campaign" ? "menu-item-selected" : ""} onClick={this.switchMenu}>Campaign</li>
            <li id="header-menu-logs" className={this.state.selectedMenu === "header-menu-logs" ? "menu-item-selected" : ""} onClick={this.switchMenu}>Logs</li>
            <li id="header-menu-coldsmtp" className={this.state.selectedMenu === "header-menu-coldsmtp" ? "menu-item-selected" : ""} onClick={this.switchMenu}>Cold SMTP</li>
          </ul>
        </div>
        <div className="UserHeader-user-info">
          <div className="UserHeader-user-email">{this.props.auth.email}</div>
          <div className="UserHeader-user-logout" onClick={this.props.logOut}>Logout</div>
        </div>

      </div>


    );
  }
}


const mapStateToProps = (state) => {
  return { auth: state.auth };
};

export default connect(mapStateToProps, { logOut, switchHomeSection })(UserHeader);
